import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { auth,db } from './firebase';

import NavbarComponent from './components/NavbarComponent';
import FooterComponent from './components/FooterComponent';

import { createUserWithEmailAndPassword, signOut } from "firebase/auth";



const PropFundingEmailAccess = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);
  
    if (!email.trim()) {
      setError("Please enter a valid email.");
      return;
    }
  
    try {
      setLoading(true);
  
      // ✅ Format joineddate string
      const now = new Date();
      const joineddate = now.toISOString().replace("T", " ").replace("Z", " +0000");
  
      // ✅ Generate a temporary password
      const tempPassword = Math.random().toString(36).slice(-8); // e.g. "4jd9s2kq"
  
      // ✅ Create Firebase Auth user silently
      const userCred = await createUserWithEmailAndPassword(auth, email.trim(), tempPassword);
  
      // ✅ Save to Firestore as well
      await addDoc(collection(db, "users"), {
        userid: userCred.user.uid,
        emailaddress: email.trim(),
        campaign: "London Prop Funding Show",
        isactive: "1",
        channel: "1",
        joineddate: joineddate,
        temppassword: tempPassword, // optional, for debugging
      });
  
      // ✅ Log out so they aren’t auto-signed in
      await signOut(auth);
  
      setSuccessMessage("✅ Access granted! Redirecting...");
      setTimeout(() => {
        navigate('/ask-the-chart-prop-funding', { replace: true });
      }, 1200);
  
    } catch (err) {
      console.error("❌ Firebase Auth Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div style={{ fontFamily: 'Nunito Sans', backgroundColor: '#FFF8F2', color: '#232830', minHeight: '100vh' }}>
      <NavbarComponent />
      <main className="container my-5">
        <Row className="justify-content-center">
          <Col md={7} style={{
            background: '#FFFFFF',
            borderRadius: '24px',
            padding: '40px',
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.1)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '50px', marginBottom: '20px' }}>📈</div>
            <h2 style={{
              fontSize: '26px',
              fontWeight: '800',
              color: '#28A745',
              marginBottom: '16px'
            }}>
              Continue with Prop Trading AI Chart
            </h2>
            <p style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#FF7C24',
              marginBottom: '24px'
            }}>
              Enter your email to access <strong>the Live Chart</strong>
            </p>

            <form onSubmit={handleEmailSubmit}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '12px',
                  border: '1px solid #ccc',
                  marginBottom: '16px',
                  fontSize: '16px',
                  fontFamily: 'Nunito Sans'
                }}
              />
              <button
                type="submit"
                disabled={loading}
                style={{
                  backgroundColor: '#FF7C24',
                  color: '#fff',
                  fontWeight: '700',
                  padding: '12px 24px',
                  borderRadius: '12px',
                  fontSize: '16px',
                  border: 'none',
                  cursor: 'pointer',
                  width: '100%'
                }}
              >
                {loading ? "Submitting..." : "Continue"}
              </button>
            </form>

            {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}
            {successMessage && <p style={{ color: 'green', marginTop: '1rem' }}>{successMessage}</p>}
          </Col>
        </Row>
      </main>
      <FooterComponent />
    </div>
  );
};

export default PropFundingEmailAccess;



// import React, { useState } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import {
//   createUserWithEmailAndPassword,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   fetchSignInMethodsForEmail,
// } from 'firebase/auth';
// import {
//   collection,
//   addDoc,
//   serverTimestamp,
// } from 'firebase/firestore';
// import { Timestamp } from 'firebase/firestore';

// import styled, { keyframes } from 'styled-components';




// import NavbarComponent from './components/NavbarComponent';
// import FooterComponent from './components/FooterComponent';
// import AuthForm from './components/AuthForm';
// import { auth, db } from './firebase';
// import { fetchUserDetails } from './datafetch/fetchUserDetails';
// import { useUser } from './sessionmanagement/UserContext';
// import { initializeUserStats } from './datafetch/initializeUserStats';

// const AgentAccess = () => {
//   const [isSignUp, setIsSignUp] = useState(false);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [resetMode, setResetMode] = useState(false);
//   const [resetEmail, setResetEmail] = useState('');
//   const navigate = useNavigate();
//   const { setUserDetails } = useUser();

//   const toggleAuthMode = () => {
//     setIsSignUp(!isSignUp);
//     setError(null);
//     setSuccessMessage(null);
//   };

//   const handleAuth = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setSuccessMessage(null);

//     const errorMapping = {
//       "auth/user-not-found": "❌ We can't recognize you. Try again.",
//       "auth/wrong-password": "❌ We can't recognize you. Try again.",
//       "auth/invalid-email": "❌ We can't recognize you. Try again.",
//       "auth/too-many-requests": "❌ Too many failed attempts. Please try again later.",
//       "auth/email-already-in-use": "❌ This email is already registered. Try logging in.",
//       "auth/weak-password": "❌ Your password is too weak. Choose a stronger one."
//     };

//     try {
//       let userCredential;
//       if (isSignUp) {
//         console.log("🔥 Signing up...");
//         userCredential = await createUserWithEmailAndPassword(auth, email, password);
//         const user = userCredential.user;

//         await addDoc(collection(db, "users"), {
//           userid: user.uid,
//           emailaddress: user.email,
//           firstname: "",
//           lastname: "",
//           isactive: "1",
//           channel: "1",  // Web = 1 
//           joineddate: Timestamp.now(),
//         });

//         await initializeUserStats(user.uid);
//         setSuccessMessage('Signup Successful!');
//       } else {
//         //console.log("🔥 Logging in...");
//         userCredential = await signInWithEmailAndPassword(auth, email, password);
//       }

//       const user = userCredential.user;
//       const details = await fetchUserDetails(user.uid);
//       setUserDetails(details);

//       //console.log("✅ Auth success! Redirecting to /ask-the-chart");
//       navigate('/ask-the-chart', { replace: true });

//     } catch (err) {
//       console.error("❌ Firebase Auth Error:", err);
//       const friendlyMessage = errorMapping[err.code] || "❌ Something went wrong.";
//       setError(friendlyMessage);
//     }
//   };

//   const handlePasswordReset = async () => {
//     try {
//       setError(null);
//       setSuccessMessage(null);
//       const methods = await fetchSignInMethodsForEmail(auth, resetEmail);

//       if (methods.length > 0) {
//         await sendPasswordResetEmail(auth, resetEmail);
//         setSuccessMessage("Password reset email sent.");
//       } else {
//         setError("Email not found.");
//       }
//     } catch (error) {
//       setError("Failed to send password reset email.");
//     }
//   };

//   return (
//     <div style={{ fontFamily: 'Nunito Sans', backgroundColor: '#FFF8F2', color: '#232830', minHeight: '100vh' }}>
//       <NavbarComponent />
//       <main className="container my-5">
//         <Row className="justify-content-center">
//           <Col md={7} style={{
//             background: '#FFFFFF',
//             borderRadius: '24px',
//             padding: '40px',
//             boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.1)',
//             textAlign: 'center',
//             animation: 'bounceIn 0.8s ease'
//           }}>
//             <div style={{ fontSize: '50px', marginBottom: '20px' }}>🤖</div>
//             <h2 style={{
//               fontSize: '28px',
//               fontWeight: '800',
//               color: '#28A745',
//               borderRadius: '20px',
//               padding: '12px',
//               backgroundColor: '#E6FFE6',
//               display: 'inline-block'
//             }}>
//               Access FinTorro AI Agents
//             </h2>
//             <p style={{
//               fontSize: '18px',
//               fontWeight: '600',
//               color: '#FF7C24',
//               borderRadius: '12px',
//               backgroundColor: '#FFF1E6',
//               padding: '10px 16px',
//               marginTop: '16px'
//             }}>
//               Login or Sign Up to unlock <strong>AI Powered Tools</strong>
//             </p>
//             <div className="mt-4">
//               <AuthForm
//                 isSignUp={isSignUp}
//                 setIsSignUp={setIsSignUp}
//                 email={email}
//                 setEmail={setEmail}
//                 password={password}
//                 setPassword={setPassword}
//                 handleAuth={handleAuth}
//                 toggleAuthMode={toggleAuthMode}
//                 resetMode={resetMode}
//                 setResetMode={setResetMode}
//                 resetEmail={resetEmail}
//                 setResetEmail={setResetEmail}
//                 sendPasswordReset={handlePasswordReset}
//                 error={error}
//                 setError={setError}
//                 successMessage={successMessage}
//               />
//             </div>
//           </Col>
//         </Row>
//       </main>
//       <FooterComponent />

//       {/* CSS animation styles */}
//       <style>{`
//         @keyframes bounceIn {
//           0% {
//             opacity: 0;
//             transform: scale(0.9);
//           }
//           60% {
//             opacity: 1;
//             transform: scale(1.05);
//           }
//           100% {
//             transform: scale(1);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AgentAccess;
